import { createContext, useContext } from 'react';

import { MeterBarChartDataProviderData } from '../types/meter-bar-chart-internal.js';

export const MeterBarChartDataContext =
  createContext<MeterBarChartDataProviderData>(
    {} as MeterBarChartDataProviderData,
  );

export const useMeterBarChartData = () => useContext(MeterBarChartDataContext);
